<template>
    <div class="column has-text-centered">
        <h3 class="title">Garage Hidden fields</h3>
        <loader :loading="getLoaderStatus"
                    :color="options.color"
                    :size="options.size" />
        <div class="field is-horizontal" v-if="!getLoaderStatus">
            <div class="field-body">
                <div class="field">
                    <label class="checkbox">
                        <input v-model="resultPrice" :checked="true" type="checkbox">
                        Hide result price
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Loader from 'vue-spinner/src/ClipLoader'
    export default {
        components: {
            Loader
        },
        computed: {
            options() {
                return this.$store.getters.getOptions
            },
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
            resultPrice: {
                get() {
                   return this.$store.getters.getUserCarHiddenFieldsResultPriceStatus
                },
                set(value) {
                    if (value) {
                        this.$store.dispatch('setCarHiddenFieldData', {user_id: this.$route.params.id, name: 'result_price' })
                        this.$store.dispatch('createCarHiddenField')
                    } else {
                        const fieldId = this.$store.getters.getUserCarHiddenFieldsResultPriceId
                        this.$store.dispatch('deleteUserCarHiddenField', { fieldId: fieldId, userId: this.$route.params.id })
                    }
                }
            }
        },
        mounted() {
            this.$store.dispatch('fetchUserWithCarHiddenFields', this.$route.params.id)
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/User/Tabs/Other/UserHiddenFields.vue